import { api } from "./api";

export interface Honraria {
  id: string;
  honraria: string;
  img: string;
  descricao?: string;
  ordem: number;
  criado_em: string;
  alterado_em: string;
}

export interface MilitarHonraria {
  id: string;
  militar: {
    id: string;
    nick: string;
    patente: {
      abreviacao: string;
    };
  };
  honraria: {
    id: string;
    honraria: string;
    img: string;
  };
  militarPromoveu: {
    id: string;
    nick: string;
    patente: {
      abreviacao: string;
    };
  };
  tipo: string;
  status: string;
  id_patente?: string;
  patente?: {
    id: string;
    patente: string;
    abreviacao: string;
  };
  criado_em: string;
}

export interface CreateHonrariaData {
  honraria: string;
  img: string;
  descricao?: string;
  ordem?: number;
}

export interface UpdateHonrariaData {
  honraria?: string;
  img?: string;
}

export interface AtribuirHonrariaData {
  idMilitar: string;
  idHonraria: string;
  tipo: "Grã Cruz" | "Comendador" | "Cavaleiro";
  idPatente?: string;
}

class HonrariasService {
  async listHonrarias(): Promise<Honraria[]> {
    const response = await api.get("/honrarias");
    return response.data;
  }

  async createHonraria(data: CreateHonrariaData): Promise<Honraria> {
    const response = await api.post("/honrarias", data);
    return response.data;
  }

  async updateHonraria(id: string, data: UpdateHonrariaData): Promise<Honraria> {
    const response = await api.put(`/honrarias/${id}`, data);
    return response.data;
  }

  async deleteHonraria(id: string): Promise<void> {
    await api.delete(`/honrarias/${id}`);
  }

  async listMilitarHonrarias(idMilitar?: string): Promise<MilitarHonraria[]> {
    const params = idMilitar ? { idMilitar } : {};
    const response = await api.get("/honrarias/militar-honrarias", { params });
    return response.data;
  }

  async atribuirHonraria(data: AtribuirHonrariaData): Promise<MilitarHonraria> {
    const response = await api.post("/honrarias/atribuir", data);
    return response.data;
  }

  async removerHonraria(id: string): Promise<void> {
    await api.delete(`/honrarias/militar-honraria/${id}`);
  }
}

export default new HonrariasService();
